const React = require("react");
import {
  CUSTOM_DATE_FILTER_TABLE_TYPE,
  CUSTOM_SELECT_FILTER_TABLE_TYPE,
} from "constants/RemoteDataTableContanst";
import { useSaveFilter } from "hook";
import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import { useEffect, useMemo, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { useTranslation } from "react-i18next";
import {
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import SearchTable from "../RemoteTable/search-table";
const RemoteDataTable = props => {
  const {
    keyField,
    caption,
    data,
    columns,
    page,
    sizePerPage,
    totalSize,
    onTableChange,
    rowEvents,
    selectRow,
    listRowAction,
    listMultipleRowAction,
    onSearchAllHandle,
    optionShowColumnHandel,
    children,
    loading,
    onRowsSelect,
    expandRow,
    isShowSearchAll,
    isShowPagination,
    customClassTable,
    isShowSTT,
    screenFilterCode,
    resetFilterHandle,
  } = props;

  const { mutate: saveFilter } = useSaveFilter();

  useEffect(() => {
    // reset row select when data change
    setRowSelected([]);
  }, [data]);
  const tableRef = useRef(null);
  const table1Ref = useRef(null);

  const { t, i18n } = useTranslation("common");

  const [jwtInfo, setJwtInfo] = useState(null);
  const [rowSelected, setRowSelected] = useState([]);
  const [lastFilterField, setLastFilterField] = useState(null);

  const [storeFilterBK, setStoreFilterBK] = useState({});

  const [finalColumns, setFinalColumns] = useState([]);
  useEffect(() => {
    setFinalColumns(initColumn());
  }, [JSON.stringify(columns), columns, listRowAction]);

  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    setJwtInfo(info);
  }, []);

  // Init custom column
  const initColumn = () => {
    // Col rowIndex
    const rowIndexColumn = {
      dataField: "rowIndex",
      text: t("index"),
      hidden: !isShowSTT,
      formatter: (cellContent, row, enumObject) => (
        <span>{(page - 1) * sizePerPage + enumObject + 1}</span>
      ),
    };
    // Default columns
    const initColumn = [
      ...columns.map(item => ({
        ...item,
        headerClasses: item.dataField,
      })),
    ];
    // Nếu có col expand
    if (columns.findIndex(item => item.dataField === "dfExpand") !== -1) {
      initColumn.splice(1, 0, rowIndexColumn);
    } else {
      initColumn.splice(0, 0, rowIndexColumn);
    }
    if (listRowAction?.length > 0) {
      const columnAction = {
        dataField: "action",
        text: t("action"),
        isDummyField: true,
        headerStyle: {
          textAlign: "center",
        },
        formatter: (cellContent, row, enumObject) =>
          generateAction(row, enumObject),
      };
      initColumn.push(columnAction);
    }
    return initColumn;
  };

  const scrollBottomTable = () => {
    setTimeout(() => {
      let scroll = null;
      scroll = tableRef?.current?.scrollHeight;
      tableRef.current.scrollTop = scroll;
    });
  };

  /* If > maxAction thì thành button ... */
  const maxAction = 5;
  // Filter conditionVisible of action if have
  const generateAction = (row, rowIndex) => {
    let isCurrentMonth = true;
    if (row.ttchung_nlap) {
      const currentMonth = new Date().getMonth() + 1;
      const currentNlap = new Date(row.ttchung_nlap * 1000).getMonth() + 1;
      // Setup qua tháng sẽ là hóa đơn điều chỉnh, không làm thay thế cho trường hợp hóa đơn ở trên giao diện
      if (currentNlap < currentMonth) {
        isCurrentMonth = false;
      } else {
        isCurrentMonth = true;
      }
    }
    const listActionFinal = listRowAction.filter(item => {
      // Setup qua tháng sẽ là hóa đơn điều chỉnh, không làm thay thế cho trường hợp hóa đơn ở trên giao diện
      if (item.isCurrentMonthOnly && !isCurrentMonth) {
        return false;
      }
      let isShow = checkVisibleByConditionRowData(
        item.isShow,
        row,
        item?.conditionVisible,
        item?.isShowWithCurrentUser
      );
      //   // WorkFlows action condition
      //   const workflowAction = row.workflowAction;
      //   if (item.actionCode) {
      //     isShow = false;
      //     if (workflowAction !== null && workflowAction.actions?.length) {
      //       isShow =
      //         workflowAction.actions.findIndex(
      //           action => action.code === item.actionCode
      //         ) !== -1
      //           ? true
      //           : false;
      //     }
      //   }
      return isShow;
    });
    const listActionOut = listActionFinal.slice(0, maxAction);
    const listActionMore = listActionFinal.slice(maxAction);
    return (
      <div
        className="d-flex gap-2 align-items-center justify-content-start col-action"
        style={{ lineHeight: "14px" }}
      >
        {listActionOut.map((action, index) => {
          // listDropdownFinal
          let listDropdownFinal = action.isDropdown
            ? action.listDropdown.filter((actionMore, indexMore) => {
                let isShow = checkVisibleByConditionRowData(
                  actionMore.isShow,
                  row,
                  actionMore?.conditionVisible,
                  actionMore?.isShowWithCurrentUser
                );
                return isShow;
              })
            : [];
          return (
            <React.Fragment key={index}>
              {/* Button more actions */}

              {action.isDropdown ? (
                listDropdownFinal.length > 0 && (
                  <React.Fragment>
                    <UncontrolledDropdown
                      direction="left"
                      className="text-center"
                    >
                      <DropdownToggle
                        id={"action" + index + rowIndex}
                        href="#"
                        // disabled={loading}
                        style={{
                          ...action.styleDivIcon,
                          cursor: "pointer",
                        }}
                        className="card-drop"
                        tag="i"
                        onClick={() => {
                          scrollBottomTable();
                        }}
                      >
                        {action.icon}
                        <UncontrolledTooltip
                          placement="top"
                          target={"action" + index + rowIndex}
                        >
                          {action.text}
                        </UncontrolledTooltip>
                      </DropdownToggle>
                      <DropdownMenu
                        className={`dropdown-menu-end ${
                          action?.classDropdown || "dropdown-menu-1"
                        }`}
                        style={{
                          zIndex: 5,
                          border: " 1px solid #808080d4",
                        }}
                      >
                        {listDropdownFinal.map((actionMore, indexMore) => {
                          return (
                            <DropdownItem
                              href="#"
                              key={indexMore}
                              className="d-flex gap-3 align-items-center"
                              onClick={() => {
                                actionMore.onClick &&
                                  actionMore.onClick(row, rowIndex);
                              }}
                            >
                              {actionMore.icon}
                              {actionMore.text}
                            </DropdownItem>
                          );
                        })}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </React.Fragment>
                )
              ) : (
                <div
                  id={"action" + index + rowIndex}
                  style={{
                    ...action.styleDivIcon,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    // if (loading) return;
                    action.onClick && action.onClick(row, rowIndex);
                  }}
                >
                  {action.icon}
                  <UncontrolledTooltip
                    placement="top"
                    target={"action" + index + rowIndex}
                  >
                    {action.text}
                  </UncontrolledTooltip>
                </div>
              )}
              {index === maxAction - 1 && listActionMore.length > 0 && (
                <UncontrolledDropdown direction="left" className="text-center">
                  <DropdownToggle
                    id={"actionMore" + index + rowIndex}
                    href="#"
                    // disabled={loading}
                    // style={{ cursor: loading ? "not-allowed" : "pointer" }}
                    style={{ cursor: "pointer" }}
                    className="card-drop"
                    tag="i"
                  >
                    <i
                      className="mdi mdi-dots-vertical font-size-18"
                      onClick={() => {
                        scrollBottomTable();
                      }}
                    />
                  </DropdownToggle>
                  <UncontrolledTooltip
                    placement="top"
                    target={"actionMore" + index + rowIndex}
                  >
                    {t("moreAction")}
                  </UncontrolledTooltip>
                  <DropdownMenu
                    className="dropdown-menu-end"
                    style={{ zIndex: 5, border: " 1px solid #808080d4" }}
                  >
                    {listActionMore.map((actionMore, indexMore) => {
                      return (
                        <DropdownItem
                          href="#"
                          key={indexMore}
                          className="d-flex gap-3 align-items-center"
                          style={{
                            ...actionMore.styleDivIcon,
                          }}
                          onClick={() => {
                            actionMore.onClick &&
                              actionMore.onClick(row, rowIndex);
                          }}
                        >
                          {actionMore.icon}
                          {actionMore.text}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  // }
  useEffect(() => {
    if (!loading && lastFilterField) {
      let timer1 = setTimeout(() => {
        const tr = tableRef.current
          .getElementsByClassName("table")[0]
          .getElementsByTagName("tr")[0];
        if (tr) {
          const element = tr
            ?.getElementsByClassName(lastFilterField)[0]
            ?.getElementsByTagName("label")[0]
            ?.getElementsByClassName("text-filter")[0];
          if (element) {
            element.focus();
          }
        }
      });
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [loading, lastFilterField]);

  const FILTER_DATE_COMPARATOR = {
    "~": "~",
    "=": "eq",
    "!=": "neq",
    ">": "gt",
    ">=": "gte",
    "<": "lt",
    "<=": "lte",
  };

  // Format data
  const formatDataTable = (
    type,
    { page, sizePerPage, sortField, sortOrder, filters }
  ) => {
    // Get last filter to focus again
    const currentFilterFocus = document.activeElement.id;
    const lastFilterField = currentFilterFocus.split("text-filter-column-");
    if (lastFilterField.length === 2) {
      setLastFilterField(lastFilterField[1]);
    }
    //
    sortOrder = sortOrder === "desc" ? "-" : "";
    // Filter
    const columnFilter = {};
    const columnFilterValue = {};
    for (const key in filters) {
      const filterType = filters[key].filterType;
      const filterVal = filters[key].filterVal;
      let comparatorFilter = null;
      let isSaveFilterValue = true;
      const fieldInColumns = columns.find(item => item.dataField === key);
      const { customKeyValueSearch, fieldSearch } = fieldInColumns;
      switch (filterType) {
        case "SELECT":
          if (customKeyValueSearch) {
            const search = customKeyValueSearch[filterVal];
            columnFilter[search.key] = search.value;
          } else {
            if (fieldSearch) {
              columnFilter[fieldSearch] = filterVal;
            } else {
              columnFilter[`filter[${key}]`] = filterVal.trim() || undefined;
            }
          }
          break;
        case "TEXT":
          const finalValue = filterVal.trim();
          if (fieldSearch) {
            columnFilter[fieldSearch] = finalValue;
          } else if (key.indexOf("khhdon") > -1) {
            if (!isNaN(finalValue[0])) {
              const splitPrefix = key.split("khhdon");
              const prefix = splitPrefix.length === 2 ? splitPrefix[0] : "";

              const split = (str, index) => {
                const result = [str.slice(0, index), str.slice(index)];
                return result;
              };

              const [ttchung_khmshdon, ttchung_khhdon] = split(finalValue, 1);
              columnFilter[`filter[${prefix}khmshdon]`] =
                ttchung_khmshdon.toUpperCase();
              columnFilter[`filter[${prefix}khhdon][like]`] =
                ttchung_khhdon.toUpperCase() || undefined;
            } else {
              columnFilter[`filter[${key}][like]`] =
                finalValue.toUpperCase() || undefined;
            }

            comparatorFilter = "like";
          } else {
            if (
              key === "id" ||
              key === "batch_id" ||
              key === "root_id" ||
              key === "child_id" ||
              key === "invoice_id" ||
              key === "invoice_error_id" ||
              key === "ttoan_tgtttbso" ||
              key === "mccqt"
            ) {
              columnFilter[`filter[${key}]`] = finalValue || undefined;
            } else {
              columnFilter[`filter[${key}][like]`] = finalValue || undefined;
              comparatorFilter = "like";
            }
          }
          break;
        case CUSTOM_DATE_FILTER_TABLE_TYPE:
          if (filterVal.date && filterVal.date.length > 0) {
            let dateCustom = [];
            for (const filterDate of filterVal.date) {
              const offset = filterDate.getTimezoneOffset();
              const date = new Date(filterDate.getTime() - offset * 60 * 1000);
              dateCustom.push(date.toISOString().split("T")[0]);
            }
            const comparatorCustom =
              FILTER_DATE_COMPARATOR[filterVal.comparator];
            if (dateCustom && comparatorCustom) {
              if (dateCustom.length > 1) {
                columnFilter[`filter[${key}][gte]`] = dateCustom[0];
                columnFilter[`filter[${key}][lte]`] = dateCustom[1];
              } else {
                const date = dateCustom[0];
                columnFilter[`filter[${key}][${comparatorCustom}]`] = date;
              }
            }
            comparatorFilter = comparatorCustom;
            // If comparator empty then not save
            if (comparatorFilter === undefined) {
              isSaveFilterValue = false;
            }
          }
          break;
        case "DATE":
          const date = filterVal.date;
          const comparator = FILTER_DATE_COMPARATOR[filterVal.comparator];
          if (date && comparator) {
            columnFilter[`filter[${key}][${comparator}]`] = date
              .toISOString()
              .split("T")[0];
          }
          comparatorFilter = comparator;
          break;
        case CUSTOM_SELECT_FILTER_TABLE_TYPE:
          if (filterVal.data && filterVal.data.value) {
            columnFilter[`filter[${key}]`] = filterVal.data.value;
          }
          break;
        default:
          break;
      }
      //
      if (isSaveFilterValue) {
        columnFilterValue[key] = {
          value: filterVal,
          comparator: comparatorFilter,
          filterType,
        };
      }
    }
    //
    if (screenFilterCode) {
      saveFilter({
        screenFilterCode,
        columnFilter,
        columnFilterValue,
      });
      setStoreFilterBK({
        columnFilter,
        columnFilterValue,
      });
    }
    onTableChange(type, {
      page,
      sizePerPage,
      sortField,
      sortOrder,
      columnFilter,
      lastFilterField,
    });
  };

  const MODE_CHECKBOX = "checkbox";
  const MODE_RADIO = "radio";

  /* START custom row select (checkbox / radio ...)  */
  const handleOnSelect = (row, isSelect) => {
    let data = [];

    if (selectRowCustom.mode === MODE_CHECKBOX) {
      if (isSelect) {
        data = [...rowSelected, row[keyField]];
      } else {
        data = rowSelected.filter(x => x !== row[keyField]);
      }
    } else if (selectRowCustom.mode === MODE_RADIO) {
      data = [row[keyField]];
    }
    setRowSelected(data);
    onRowsSelect && onRowsSelect(data);
  };

  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map(r => r[keyField]);
    let data = [];
    if (isSelect) {
      data = ids;
    }
    setRowSelected(data);
    onRowsSelect && onRowsSelect(data);
  };

  const selectRowCustom = {
    clickToSelect: false,
    ...selectRow,
    selected: rowSelected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  /* END custom row select (checkbox / radio ...)  */

  /* START custom noData  */
  const defaultEmptyDataMessage = () => {
    return <div className="text-center">{t("table_empty")}</div>;
  };
  /* END custom noData  */

  /* START loading (skeleton / thanh chạy)  */
  // Chưa có gì để xem -> vẽ skeleton cho giữ đúng khung bảng
  const isFirstLoad = loading && !(data?.length > 0);
  // Đã có dữ liệu (lọc, đổi trang, đổi chi nhánh...) -> giữ bảng cũ cho đọc tiếp
  const isRefetching = loading && data?.length > 0;

  // Bề rộng cố định theo vị trí cột để skeleton không nhấp nháy mỗi lần render
  const SKELETON_BAR_WIDTHS = ["70%", "45%", "90%", "60%", "80%", "55%"];
  const skeletonData = useMemo(
    () =>
      Array.from({ length: Math.min(sizePerPage || 10, 8) }, (_, index) => ({
        [keyField]: `__skeleton_${index}`,
      })),
    [sizePerPage, keyField]
  );

  const buildSkeletonColumns = cols =>
    cols.map((col, index) => ({
      ...col,
      formatter: () => (
        <span
          className="rt-skeleton-bar"
          style={{
            width: SKELETON_BAR_WIDTHS[index % SKELETON_BAR_WIDTHS.length],
          }}
        />
      ),
    }));

  // Không cho chọn/bấm vào dòng skeleton, nhưng vẫn giữ cột checkbox
  // để lúc dữ liệu về không bị xê dịch cột
  const skeletonSelectRow = {
    ...selectRowCustom,
    selected: [],
    nonSelectable: skeletonData.map(row => row[keyField]),
  };
  /* END loading (skeleton / thanh chạy)  */

  const checkVisibleByConditionRowData = (
    isShowData,
    rowData,
    conditionVisibleData,
    isShowWithCurrentUser
  ) => {
    if (isShowData === false) {
      return false;
    }
    let isShow = isShowData !== undefined ? isShowData : true;
    // Normal action condition
    const conditionVisible = conditionVisibleData;
    for (const key in conditionVisible) {
      const k = key.split(".");
      let lastValue = rowData;
      for (const item of k) {
        lastValue =
          lastValue?.[item] !== undefined && lastValue !== null
            ? lastValue[item]
            : null;
      }
      if (conditionVisible[key].length === 0) {
        isShow = lastValue ? true : false;
      } else {
        if (
          lastValue !== undefined &&
          lastValue !== null &&
          conditionVisible[key].findIndex(c => c === lastValue) === -1
        ) {
          isShow = false;
        }
      }
    }

    // Check show when it is create from current user
    if (isShowWithCurrentUser) {
      const userCode = jwtInfo?.userInfo?.userCode;
      if (userCode === rowData?.["maker_id"]) {
        isShow = true;
      }
    }
    return isShow;
  };

  return (
    finalColumns.length > 0 && (
      <PaginationProvider
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
          custom: true,
          sizePerPageList: [
            {
              text: "10",
              value: 10,
            },
            {
              text: "25",
              value: 25,
            },
            {
              text: "35",
              value: 35,
            },
            {
              text: "50", // max from api
              value: 50,
            },
          ],
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField={keyField}
            columns={finalColumns}
            data={data}
            columnToggle
          >
            {toolkitProps => (
              <React.Fragment>
                {isShowSearchAll && (
                  <SearchTable
                    loading={loading}
                    isShowResetFilter={resetFilterHandle ? true : false}
                    resetFilterHandle={() => {
                      setFinalColumns([]);
                      if (screenFilterCode) {
                        saveFilter({
                          screenFilterCode,
                          isClearFilter: true,
                        });
                      }
                      resetFilterHandle && resetFilterHandle();
                    }}
                    optionShowColumnHandel={(field, value, columnsVisible) => {
                      if (screenFilterCode) {
                        let fieldRemoveFilter = null;
                        let filterQueryAdd = null;
                        let filterValueAdd = null;
                        // If hide then remove filter
                        if (!value) {
                          fieldRemoveFilter = field;
                        } else if (storeFilterBK) {
                          // If show then backup filter
                          if (storeFilterBK["columnFilterValue"]) {
                            filterValueAdd = {
                              [field]:
                                storeFilterBK["columnFilterValue"][field],
                            };
                          }
                          for (const key in storeFilterBK["columnFilter"]) {
                            if (key.indexOf(field) > -1) {
                              filterQueryAdd = {
                                [key]: storeFilterBK["columnFilter"][key],
                              };
                            }
                          }
                        }
                        saveFilter({
                          screenFilterCode,
                          columnsVisibleInvoice: columnsVisible,
                          fieldRemoveFilter,
                          filterQueryAdd,
                          filterValueAdd,
                        });
                      }
                      optionShowColumnHandel &&
                        optionShowColumnHandel(field, value);
                    }}
                    onSearchAllHandle={value => {
                      setLastFilterField(null);
                      onSearchAllHandle && onSearchAllHandle(value);
                    }}
                    columnToggleProps={toolkitProps.columnToggleProps}
                    rowSelected={rowSelected}
                    listMultipleRowAction={listMultipleRowAction}
                  >
                    {children}
                  </SearchTable>
                )}
                <Row>
                  <Col xl="12">
                    <div
                      className={`rt-table-loading-wrap ${
                        isRefetching ? "rt-refetching" : ""
                      }`}
                    >
                      {isRefetching && <span className="rt-table-progress" />}
                      <div
                        className={`table-responsive ${customClassTable}`}
                        ref={tableRef}
                      >
                        <BootstrapTable
                          remote
                          ref={table1Ref}
                          caption={caption}
                          filter={filterFactory()}
                          wrapperClasses={
                            listRowAction?.length > 0 ? "table-col-action" : ""
                          }
                          responsive
                          selectRow={
                            selectRow
                              ? isFirstLoad
                                ? skeletonSelectRow
                                : selectRowCustom
                              : undefined
                          }
                          expandRow={expandRow ? expandRow : undefined}
                          hover={true}
                          rowEvents={isFirstLoad ? undefined : rowEvents}
                          onTableChange={formatDataTable}
                          noDataIndication={defaultEmptyDataMessage}
                          bordered={true}
                          // striped={true}
                          classes={"table align-middle table-nowrap"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                          // Đặt sau các spread để lúc loading lần đầu thì thay
                          // nội dung bảng bằng skeleton (header/filter giữ nguyên)
                          data={
                            isFirstLoad
                              ? skeletonData
                              : toolkitProps.baseProps.data
                          }
                          columns={
                            isFirstLoad
                              ? buildSkeletonColumns(
                                  toolkitProps.baseProps.columns
                                )
                              : toolkitProps.baseProps.columns
                          }
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                {isShowPagination && (
                  <Row
                    className="align-items-md-center mt-30"
                    style={{ marginTop: "5px" }}
                  >
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    )
  );
};

RemoteDataTable.propTypes = {
  isShowPagination: PropTypes.bool,
  loading: PropTypes.bool,
  keyField: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  totalSize: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  rowEvents: PropTypes.object,
  columnToggleProps: PropTypes.any,
  children: PropTypes.any,
  onSearchAllHandle: PropTypes.func, // call back button tìm kiếm
  optionShowColumnHandel: PropTypes.func, // call back button ẩn hiện column
  listRowAction: PropTypes.array, // action từng dòng
  listMultipleRowAction: PropTypes.array, // action button tác vụ hàng loạt
  selectRow: PropTypes.object,
  onRowsSelect: PropTypes.func, // call back when select row (Checkbox / radio)
  expandRow: PropTypes.object,
  isShowSearchAll: PropTypes.bool,
  customClassTable: PropTypes.any,
  caption: PropTypes.any,
  isShowSTT: PropTypes.any,
  screenFilterCode: PropTypes.any,
  resetFilterHandle: PropTypes.any,
};

RemoteDataTable.defaultProps = {
  isShowSTT: true,
  caption: undefined,
  isShowSearchAll: true,
  isShowPagination: true,
  customClassTable: "custom-remote-table",
  screenFilterCode: null,
};

export default RemoteDataTable;
